    //菜单数据
    let nav_data = [{
        title: "首页",
        nav_id: "1",
        children: [{
            title: "24猎全职数据",
            nav_id: "1-1",
            icon: "iconshuju",
            // 代理商有首页数据
            onshow: [100, 90, 60, 80],
            path: "/index",
            // onshow: 100
          },
          {
            title: "24猎零工数据",
            nav_id: "1-2",
            icon: "iconshuju",
            // 代理商有首页数据
            onshow: [100, 90, 60, 80],
            path: "/odd_job_index",
            // onshow: 100
          },
          {
            title: "劳务巴士数据",
            nav_id: "1-3",
            icon: "iconshuju1",
            path: "/lw_index",
            onshow: [100],
          },
          {
            title: "求职者信息举报",
            nav_id: "1-4",
            icon: "iconjubao",
            path: "/report_personnel",
            onshow: [80],
          },
        ],
        // 代理商有首页数据
        onshow: [100, 90, 80, 60],
      },
      {
        title: "24猎管理",
        nav_id: "2",
        children: [{
            title: "创建帐户",
            nav_id: "2-1",
            icon: "iconzhuce",
            path: "/add_user",
            onshow: [100, 61],
          },
          {
            title: "全职注册管理",
            nav_id: "2-2",
            icon: "iconzhuce",
            path: "/auit_resume",
            onshow: [100, 61],
          },
          {
            title: "零工注册管理",
            nav_id: "2-3",
            icon: "iconzhuce",
            path: "/oddJob_resume",
            onshow: [100, 61],
          },
          {
            title: "用户查询修改",
            nav_id: "2-5",
            icon: "iconchaxun1",
            path: "/inquire_resume",
            onshow: [100, 61],
          },
          {
            title: "小程序码海报更新",
            nav_id: "2-6",
            icon: "iconhaibao",
            path: "/photo_upload",
            onshow: [100],
          },
          {
            title: "企微码海报更新",
            nav_id: "2-7",
            icon: "iconhaibao",
            path: "/enterprise_photo_upload",
            onshow: [100],
          },
          {
            title: "视频更新",
            nav_id: "2-8",
            icon: "iconshipin",
            path: "/video_upload",
            onshow: [100],
          },
          {
            title: "删除简历",
            nav_id: "2-9",
            icon: "iconshanchu",
            path: "/delete_resume",
            onshow: [100],
          },
          {
            title: "还原密码",
            nav_id: "2-10",
            icon: "iconhuanyuan",
            path: "/change_psd",
            onshow: [100, 61],
          },
          {
            title: "修改账号密码",
            nav_id: "2-11",
            icon: "iconaccount",
            path: "/user_change",
            onshow: [100, 61],
          },
          {
            title: "高薪警告",
            nav_id: "2-12",
            icon: "icongaoxin",
            path: "/high_salary",
            onshow: [100],
          },
          {
            title: "举报列表",
            nav_id: "2-13",
            icon: "iconjubao",
            path: "/report",
            onshow: [100],
          },
          {
            title: "招商加盟",
            nav_id: "2-14",
            icon: "iconzixun",
            path: "/consulting_service",
            onshow: [100],
          },
          {
            title: "职位审核",
            nav_id: "2-15",
            icon: "iconshenhe",
            path: "/position_review",
            onshow: [100, 61],
          },
          {
            title: "视频审核",
            nav_id: "2-16",
            icon: "iconshipin",
            path: "/audit_video",
            onshow: [100],
          },
          {
            title: "求职者信息举报",
            nav_id: "2-17",
            icon: "iconshenhe",
            path: "/report_personnel",
            onshow: [100],
          },
        ],
        onshow: [100, 61],
      },
      {
        title: "充值管理",
        nav_id: "3",
        children: [{
            title: "充值客户提单",
            nav_id: "3-1",
            icon: "iconmubiaoshezhi",
            path: "/prepaidCustomerBillOfLading",
            onshow: [100, 61, 60, 80, 20, 30],
          },

        ],
        onshow: [100, 61, 80, 20, 30, 60],
      },
      {
        title: "销售管理",
        nav_id: "4",
        children: [{
            title: "管理看板",
            nav_id: "4-1",
            icon: "icontongji_tuanduishuju",
            path: "/team_data",
            onshow: [100, 90, 80, 30],
          },
          {
            title: "我的数据",
            nav_id: "4-2",
            icon: "iconshuju",
            path: "/me_data",
            onshow: [100, 80, , 30, 20],
          },
          {
            title: "基础工作",
            nav_id: "4-3",
            icon: "iconchunxueicon--",
            path: "/basics_job",
            onshow: [100, 80, , 30, 20],
          },
          {
            title: "我的客户",
            nav_id: "4-4",
            icon: "iconkehuguanli",
            path: "/client",
            onshow: [100, 80, , 30, 20],
          },
          {
            title: "客户公海",
            nav_id: "4-5",
            icon: "icongonghai",
            path: "/open_sea",
            onshow: [100, 80, , 30, 20],
          },
          {
            title: "提单管理",
            nav_id: "4-6",
            icon: "icontidanguanli",
            path: "/bill_of_lading",
            onshow: [100, 90, 80, , 30, 20],
          },
          {
            title: "审核管理",
            nav_id: "4-7",
            icon: "iconshenhe",
            path: "/to_examine",
            onshow: [100, 90, 80],
          },
          {
            title: "帐号管理",
            nav_id: "4-8",
            icon: "iconzhanghaoshezhi",
            path: "/accounts_m",
            onshow: [100, 80, 30],
          },
          {
            title: "私海设置",
            nav_id: "4-9",
            icon: "iconshijianshezhi_tianqing",
            path: "/staff_setup",
            onshow: [100, 80, 30],
          },
          {
            title: "目标设置",
            nav_id: "4-10",
            icon: "iconmubiaoshezhi",
            path: "/target_setting",
            onshow: [100, 90, 80, 30],
          },


        ],
        onshow: [100, 90, 80, 30, 20],
      },



      {
        title: "劳务巴士",
        nav_id: "6",
        children: [{
            title: "创建账号",
            nav_id: "6-1",
            icon: "iconkehuguanli",
            path: "/establish",
            onshow: [100],
          },
          {
            title: "修改账号密码",
            nav_id: "6-2",
            icon: "iconhuanyuan",
            path: "/lw_change_ps",
            onshow: [100],
          },
          {
            title: "客户管理",
            nav_id: "6-3",
            icon: "iconkehu",
            path: "/customer_management",
            onshow: [100],
          },
        ],
        onshow: [100],
      },
      {
        title: "人事管理",
        nav_id: "7",
        children: [{
            title: "人事账号",
            nav_id: "7-1",
            icon: "iconkehuguanli",
            path: "/personnel_creation",
            onshow: [100, 50],
          },
          {
            title: "组织架构管理",
            nav_id: "7-2",
            icon: "iconshuju",
            path: "/organizational_structure",
            onshow: [100, 50],
          },
          {
            title: "考勤管理",
            nav_id: "7-3",
            icon: "iconshuju",
            path: "/check_work_attendance",
            onshow: [100, 50],
          },
          {
            title: "员工管理",
            nav_id: "7-4",
            icon: "iconshuju",
            path: "/staff_management",
            onshow: [100, 50],
          },
        ],
        onshow: [100000000000],
      },
      {
        title: "猎零云管理",
        nav_id: "8",
        children: [{
          title: "创建账号",
          nav_id: "8-1",
          icon: "iconkehuguanli",
          path: "/create_lie",
          onshow: [100, 60],
        }, {
          title: "修改账号密码",
          nav_id: "8-2",
          icon: "iconkehuguanli",
          path: "/restore",
          onshow: [100, 60],
        },  {
          title: "客户管理",
          nav_id: "8-3",
          icon: "iconkehuguanli",
          path: "/hrs_customer",
          onshow: [100, 60],
        }, ],
        onshow: [100, 60],
      }
      
    ]
    export {
      nav_data
    }



// WEBPACK FOOTER //
// ./src/utils/nav.js